import React, {useState} from 'react';
import { useDispatch } from 'react-redux';
import { utils, write } from "xlsx";

import { getStockAgingReportRaw } from '../../services/api/stockWarehouse';
import Loading from '../../common/Loading';
import { raiseToast } from '../../services/redux/reducers/toast/toast';
import { Button, CalendarField } from '../../helpers';
import { getDateString, round } from '../../utils';


const StockReportRaw = () => {
    const [date, setDate] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const dispatch = useDispatch()

    const getStockReportRaw = async () => {
        console.log("date", date, date.toISOString().split("T")[0])
        if(!date){
            return dispatch(raiseToast({severity:'error', detail:'Please select date'}))
        }

        setIsLoading(true)
        const data = {
            //fromDate: date,
            fromDate: '2025-03-30T18:30:00.000Z',
            date: date.toISOString().split("T")[0],
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true,
            searchBy: 'all',
            searchText: '',
            docType: [],
            dataType: 'stockAging',
            dateType: 'reportDate',
            range: null,
            paginator: false
        }
        const response = await getStockAgingReportRaw(data)
        setIsLoading(false)

        console.log("response", response)

        if(response.data.file){
            const base64Data = response.data.file.split(",")[1];

            const byteCharacters = atob(base64Data)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })

            const link = document.createElement("a")
            link.href = URL.createObjectURL(blob)
            link.download = `stock_report_${date.toISOString().split("T")[0]}.xlsx`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        } else {
            const responseData = response.data.data
            console.log("dwdata1", responseData)
            const dwdata = await downloadStockAgingReportData(responseData)
            console.log("dwdata", dwdata)
            const ws = utils.json_to_sheet(dwdata)
            const wb = utils.book_new()
            utils.book_append_sheet(wb, ws, 'Sheet1')
            const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = `stock_report_${date.toISOString().split("T")[0]}.xlsx`
            a.click()
            URL.revokeObjectURL(url)
        }

        if (response.failure){
            dispatch(raiseToast({severity:'error', detail: response.data.error}))
        }
    }

    const downloadStockAgingReportData = async (stockAgingData) => {
        const stockAgingReportSheetData = []

        let count = 1
        stockAgingData.forEach(eachStock => {
            /*const newStock = {
                'Sr. No.': count,
                'MaterialId': eachStock.materialId,
                "Warehouse Name": eachStock.warehouseName,
                "Product": eachStock.product,
                'Product Specification': eachStock.productSpecification,
                'Buyer PO': eachStock['BuyerPODoc'],
                'Client Name': eachStock['clientName'],
                "Seller PO": eachStock.sellerPODocNo,
                "SellerPO Date": eachStock.sellerPODate,
                'Seller Invoice No': eachStock.sellerInvoiceNo,
                "KAM Name": eachStock.KAMName,
                "Type": eachStock['Type'],
                "Move Qty": eachStock['Qty'],
                "Price": eachStock.price,
                "Stock Value": round(eachStock.stockValue),
                "GRNDate": getGRNDates(eachStock.GRNDate),
                "Age": eachStock['Age']
            }*/
            const newStock = {
                'Sr. No.': count,
                'MaterialId': eachStock.materialId,
                "Warehouse Name": eachStock.warehouseName,
                "Product": eachStock.product,
                'Product Specification': eachStock.productSpecification,
                "Seller PO": eachStock.sellerPODocNo,
                "Qty": eachStock['Qty'],
                "Price": eachStock.price,
                "Stock Value": round(eachStock.stockValue)
            }
            count += 1

            stockAgingReportSheetData.push(newStock)
        })

        return stockAgingReportSheetData
    }

    const getGRNDates = (GRNDate) => {
        const date = new Date(GRNDate)

        return getDateString(date)
    }

    const handleSearchOnChange = (event) => {
        setDate(event.target.value)
    }

    return(
        <div className='flex flex-column'>
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">STOCK REPORT</h4> 
            </div>
            <div className='flex flex-row justify-content-center align-items-center p-4' style={{background: "white", height: "200px", width: "500px", borderRadius: "10px"}}>
                <div className="flex flex-column col w-6">
                    <CalendarField name="date" labelText="Date" value={date} onChange={handleSearchOnChange} maxDate={new Date(2025, 2, 31)} />
                </div>
                <div className="flex flex-column col w-6 mt-3">
                    <Button label="Download Report" style={{ flexGrow: 1, backgroud: "rgba(44, 222, 115, 0.5)" }} className="py-2" onClick={getStockReportRaw} />
                </div>
            </div>
            <Loading visible={isLoading}/>
        </div>
    )
}

export default StockReportRaw